<div class="dashboardAccounts">
    <div class="links">
        <a [routerLink]="['/dashboard/accounts/requests']" routerLinkActive="router-link-active">Account Requests</a>

        <a [routerLink]="['/dashboard/accounts/all']" routerLinkActive="router-link-active">All Accounts</a>

        <a [routerLink]="['/dashboard/accounts/deleted']" routerLinkActive="router-link-active">Deleted Accounts</a>
    </div>
</div>

<div class="subSection">
    <div class="requests">
        <div class="title">All Accounts</div>
        <app-csv-download [data]="activeListCsv" filename="all_accounts.csv"></app-csv-download>
    </div>
    <div class="resultsWrapper">

        <div class="row">
            <!-- <h2>Key: {{ entry[0] }}</h2> -->
            <div class="dayTitle">
                recently accounts approved: {{incompleteList.length}}
            </div>

             <div class="list">
                <div class="item" *ngFor="let profile of incompleteList">
                    <div class="itemBox">

                        <div class="label">
                            NAME
                        </div>
                        <div class="name">
                            {{profile.firstName}} {{profile.lastName}}
                        </div>
    
                        <div class="label">
                            email
                        </div>
                        <div class="email">
                            {{profile.email}}
                        </div>
    
                        <div class="label">
                            PHONE
                        </div>
                        <div class="phone">
                            {{profile.phone}}
                        </div>

                        <div class="deleteButton" (click)="deleteProfile(profile)">
                            Delete Account
                        </div>
                    </div>

                    <!-- <div class="buttons">
                        <div class="button">
                            <div class="label">Approve</div>
                        </div>
                        <div class="button">
                            <div class="label">Deny</div>
                        </div>
                    </div> -->
                </div>
            </div>
           
        </div>


        <div class="row">
            <!-- <h2>Key: {{ entry[0] }}</h2> -->
            <div class="dayTitle">
                All accounts: {{activeList.length}}
                <!-- <div class="buttonWrapper">
                    <div class="loadAll roundButton" (click)="onAllClick()">
                        <div class="label">Load All</div>
                    </div>
                </div> -->
            </div>

            <div class="list">
                <div class="item" *ngFor="let profile of activeList">
                    <div class="itemBox">

                        <div class="label">
                            NAME
                        </div>
                        <div class="name">
                            {{profile.firstName}} {{profile.lastName}}
                        </div>
    
                        <div class="label">
                            email
                        </div>
                        <div class="email">
                            {{profile.email}}
                        </div>
    
                        <div class="label">
                            PHONE
                        </div>
                        <div class="phone">
                            {{profile.phone}}
                        </div>
                        
                        <div class="split" *ngIf="profile.theaters.length">
                            <div class="left">
                                <div class="label" >
                                    CITY
                                </div>
                                <div class="address" >
                                    {{profile.theaters[0].city}}
                                </div>
                            </div>
                            <div class="right">

                                <div class="label" >
                                    STATE
                                </div>
                                <div class="address" >
                                    {{profile.theaters[0].state}}
                                </div>
                            </div>
                        </div>
                        
                        <div class="split" *ngIf="profile.bookingList.length">
                            <div class="left">
                                <div class="label" >
                                    Booking request
                                </div>
                                <div class="address" >
                                    {{profile.bookingList.length}}
                                </div>
                            </div>
                            <div class="right">

                                <div class="label" >
                                    Past Bookings
                                </div>
                                <div class="address" >
                                    0
                                </div>
                            </div>
                        </div>

                        <div class="deleteButton" (click)="deleteProfile(profile)">
                            Delete Account
                        </div>
                    </div>

                    <!-- <div class="buttons">
                        <div class="button">
                            <div class="label">Review Account</div>
                        </div>
                    </div>  -->
                </div>
            </div>
        </div>
    </div>
</div>